import { render, staticRenderFns } from "./policeIssue.vue?vue&type=template&id=2206c080&scoped=true&"
import script from "./policeIssue.vue?vue&type=script&lang=js&"
export * from "./policeIssue.vue?vue&type=script&lang=js&"
import style0 from "./policeIssue.vue?vue&type=style&index=0&id=2206c080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206c080",
  null
  
)

export default component.exports